module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (163).76c709c2.jpg";